/**
 * Translations for the Internally Created training records dialogs and the
 * date field primitives they use. Every key is prefixed with `itr-` because
 * the app merges all domain messages into a single flat namespace.
 */
const en = {
  // Shared
  'itr-save': 'Save',
  'itr-cancel': 'Cancel',
  'itr-delete': 'Delete',
  'itr-ok': 'OK',

  // TrainingOrientationDialog
  'itr-basic-info': 'Basic Info',
  'itr-employee-first-name-required': 'Employee First Name *',
  'itr-employee-last-name-required': 'Employee Last Name *',
  'itr-store-number': 'Store #',
  'itr-phone-number': 'Phone Number',
  'itr-email': 'Email',
  'itr-hired-by': 'Hired By',
  'itr-store-contact-name': 'Store Contact Name',
  'itr-store-contact-phone-number': 'Store Contact Phone Number',
  'itr-pay-rate': 'Pay Rate',
  'itr-language': 'Language',
  'itr-first-day-of-work': 'First Day of Work',
  'itr-first-day-of-work-start': 'First Day Of Work Start',
  'itr-crew-trainer': 'Crew Trainer',
  'itr-course-name': 'Course Name',
  'itr-class-time-required': 'Class Time *',
  'itr-confirmation-number': 'Confirmation Number',
  'itr-add-issue-date': '+ Issue Date',
  'itr-issue-date': 'Issue Date',
  'itr-add-expiration-date': '+ Expiration Date',
  'itr-expiration-date': 'Expiration Date',
  'itr-uniform': 'Uniform',
  'itr-uniform-type': 'Uniform Type',
  'itr-gender': 'Gender',
  'itr-hat-visor': 'Hat/Visor',
  'itr-apron': 'Apron',
  'itr-shirt-size': 'Shirt Size',
  'itr-pant-size': 'Pant Size',
  'itr-preferred-name': 'Preferred Name',
  'itr-compliance-checks': 'Compliance Checks',
  'itr-working-at-another-mcd': "Working at Another McDonald's?",
  'itr-have-a-release-letter': 'Have a Release Letter?',
  'itr-worked-at-mcd-before': "Worked at McDonald's Before?",
  'itr-did-you-check-references': 'Did You Check References?',
  'itr-add-media': 'Add Media',
  'itr-edit-training-record': 'Edit Training Record',
  'itr-add-training-record': 'Add Training Record',
  'itr-must-be-valid-email-address': 'Must be valid email address',
  'itr-phone-number-must-be-10-digits-with-or-without-dashes':
    'Phone number must be 10 digits (with or without dashes)',
  'itr-pay-rate-must-be-in-format-xx-xx': 'Pay rate must be in format XX.XX',

  // ShareOrientationDialog
  'itr-share-orientation-letter': 'Share Orientation Letter',
  'itr-view-print-orientation-letter': 'View/Print Orientation Letter',
  'itr-email-orientation-letter-to-employee': 'Email Orientation Letter to Employee',
  'itr-email-orientation-letter-to-others': 'Email Orientation Letter to Others',
  'itr-email-addresses-separated-by-comma': 'Email Address(s), separated by comma',
  'itr-required': 'Required.',
  'itr-invalid-email-address': 'Invalid email address.',
  'itr-at-least-one-email-address-is-required': 'At least one email address is required',

  // TrainingDeleteDialog
  'itr-confirm-delete': 'Confirm Delete',
  'itr-are-you-sure-you-want-to-delete-record': 'Are you sure you want to delete record',
  'itr-name-not-provided': 'Name not provided',

  // TrainingEditFormImages
  'itr-no-images': 'No Images',
  'itr-there-are-no-images-for-this-training': 'There are no images for this training.',

  // DateTimeField / DateTextField
  'itr-date': 'Date',
  'itr-time': 'Time',
  'itr-your-time': 'Your time:',
  'itr-date-placeholder': 'mm/dd/yyyy',
};

const es = {
  // Shared
  'itr-save': 'Guardar',
  'itr-cancel': 'Cancelar',
  'itr-delete': 'Eliminar',
  'itr-ok': 'Aceptar',

  // TrainingOrientationDialog
  'itr-basic-info': 'Informacion basica',
  'itr-employee-first-name-required': 'Nombre del empleado *',
  'itr-employee-last-name-required': 'Apellido del empleado *',
  'itr-store-number': 'Tienda #',
  'itr-phone-number': 'Numero de telefono',
  'itr-email': 'Correo electronico',
  'itr-hired-by': 'Contratado por',
  'itr-store-contact-name': 'Nombre del contacto de tienda',
  'itr-store-contact-phone-number': 'Telefono del contacto de tienda',
  'itr-pay-rate': 'Tarifa de pago',
  'itr-language': 'Idioma',
  'itr-first-day-of-work': 'Primer dia de trabajo',
  'itr-first-day-of-work-start': 'Inicio del primer dia de trabajo',
  'itr-crew-trainer': 'Entrenador de equipo',
  'itr-course-name': 'Nombre del curso',
  'itr-class-time-required': 'Horario de clase *',
  'itr-confirmation-number': 'Numero de confirmacion',
  'itr-add-issue-date': '+ Fecha de emision',
  'itr-issue-date': 'Fecha de emision',
  'itr-add-expiration-date': '+ Fecha de vencimiento',
  'itr-expiration-date': 'Fecha de vencimiento',
  'itr-uniform': 'Uniforme',
  'itr-uniform-type': 'Tipo de uniforme',
  'itr-gender': 'Genero',
  'itr-hat-visor': 'Gorra/Visera',
  'itr-apron': 'Delantal',
  'itr-shirt-size': 'Talla de camisa',
  'itr-pant-size': 'Talla de pantalon',
  'itr-preferred-name': 'Nombre preferido',
  'itr-compliance-checks': 'Controles de cumplimiento',
  'itr-working-at-another-mcd': "Trabaja en otro McDonald's?",
  'itr-have-a-release-letter': 'Tiene carta de liberacion?',
  'itr-worked-at-mcd-before': "Ha trabajado en McDonald's antes?",
  'itr-did-you-check-references': 'Verifico referencias?',
  'itr-add-media': 'Agregar medios',
  'itr-edit-training-record': 'Editar registro de capacitacion',
  'itr-add-training-record': 'Agregar registro de capacitacion',
  'itr-must-be-valid-email-address': 'Debe ser un correo electronico valido',
  'itr-phone-number-must-be-10-digits-with-or-without-dashes':
    'El numero de telefono debe tener 10 digitos (con o sin guiones)',
  'itr-pay-rate-must-be-in-format-xx-xx': 'La tarifa debe tener formato XX.XX',

  // ShareOrientationDialog
  'itr-share-orientation-letter': 'Compartir carta de orientacion',
  'itr-view-print-orientation-letter': 'Ver/imprimir carta de orientacion',
  'itr-email-orientation-letter-to-employee': 'Enviar carta de orientacion al empleado',
  'itr-email-orientation-letter-to-others': 'Enviar carta de orientacion a otros',
  'itr-email-addresses-separated-by-comma': 'Direcciones de correo, separadas por coma',
  'itr-required': 'Requerido.',
  'itr-invalid-email-address': 'Direccion de correo invalida.',
  'itr-at-least-one-email-address-is-required': 'Se requiere al menos una direccion de correo',

  // TrainingDeleteDialog
  'itr-confirm-delete': 'Confirmar eliminacion',
  'itr-are-you-sure-you-want-to-delete-record': 'Esta seguro de que desea eliminar el registro',
  'itr-name-not-provided': 'Nombre no proporcionado',

  // TrainingEditFormImages
  'itr-no-images': 'Sin imagenes',
  'itr-there-are-no-images-for-this-training': 'No hay imagenes para esta capacitacion.',

  // DateTimeField / DateTextField
  'itr-date': 'Fecha',
  'itr-time': 'Hora',
  'itr-your-time': 'Su hora:',
  'itr-date-placeholder': 'mm/dd/aaaa',
};

const fr = {
  // Shared
  'itr-save': 'Enregistrer',
  'itr-cancel': 'Annuler',
  'itr-delete': 'Supprimer',
  'itr-ok': 'OK',

  // TrainingOrientationDialog
  'itr-basic-info': 'Informations de base',
  'itr-employee-first-name-required': "Prénom de l'employé *",
  'itr-employee-last-name-required': "Nom de l'employé *",
  'itr-store-number': 'Restaurant #',
  'itr-phone-number': 'Numéro de téléphone',
  'itr-email': 'Courriel',
  'itr-hired-by': 'Embauché par',
  'itr-store-contact-name': 'Nom du contact du restaurant',
  'itr-store-contact-phone-number': 'Téléphone du contact du restaurant',
  'itr-pay-rate': 'Taux de rémunération',
  'itr-language': 'Langue',
  'itr-first-day-of-work': 'Premier jour de travail',
  'itr-first-day-of-work-start': 'Début du premier jour de travail',
  'itr-crew-trainer': "Formateur d'équipe",
  'itr-course-name': 'Nom du cours',
  'itr-class-time-required': 'Heure du cours *',
  'itr-confirmation-number': 'Numéro de confirmation',
  'itr-add-issue-date': "+ Date d'émission",
  'itr-issue-date': "Date d'émission",
  'itr-add-expiration-date': "+ Date d'expiration",
  'itr-expiration-date': "Date d'expiration",
  'itr-uniform': 'Uniforme',
  'itr-uniform-type': "Type d'uniforme",
  'itr-gender': 'Genre',
  'itr-hat-visor': 'Casquette/Visière',
  'itr-apron': 'Tablier',
  'itr-shirt-size': 'Taille de chemise',
  'itr-pant-size': 'Taille de pantalon',
  'itr-preferred-name': 'Nom préféré',
  'itr-compliance-checks': 'Vérifications de conformité',
  'itr-working-at-another-mcd': "Travaille dans un autre McDonald's ?",
  'itr-have-a-release-letter': 'Possède une lettre de libération ?',
  'itr-worked-at-mcd-before': "A déjà travaillé chez McDonald's ?",
  'itr-did-you-check-references': 'Avez-vous vérifié les références ?',
  'itr-add-media': 'Ajouter des médias',
  'itr-edit-training-record': 'Modifier le dossier de formation',
  'itr-add-training-record': 'Ajouter un dossier de formation',
  'itr-must-be-valid-email-address': 'Doit être une adresse courriel valide',
  'itr-phone-number-must-be-10-digits-with-or-without-dashes':
    'Le numéro de téléphone doit comporter 10 chiffres (avec ou sans tirets)',
  'itr-pay-rate-must-be-in-format-xx-xx': 'Le taux doit être au format XX.XX',

  // ShareOrientationDialog
  'itr-share-orientation-letter': "Partager la lettre d'orientation",
  'itr-view-print-orientation-letter': "Voir/imprimer la lettre d'orientation",
  'itr-email-orientation-letter-to-employee': "Envoyer la lettre d'orientation à l'employé",
  'itr-email-orientation-letter-to-others': "Envoyer la lettre d'orientation à d'autres",
  'itr-email-addresses-separated-by-comma': 'Adresse(s) courriel, séparées par des virgules',
  'itr-required': 'Obligatoire.',
  'itr-invalid-email-address': 'Adresse courriel invalide.',
  'itr-at-least-one-email-address-is-required': 'Au moins une adresse courriel est requise',

  // TrainingDeleteDialog
  'itr-confirm-delete': 'Confirmer la suppression',
  'itr-are-you-sure-you-want-to-delete-record': 'Voulez-vous vraiment supprimer le dossier',
  'itr-name-not-provided': 'Nom non fourni',

  // TrainingEditFormImages
  'itr-no-images': 'Aucune image',
  'itr-there-are-no-images-for-this-training': "Il n'y a aucune image pour cette formation.",

  // DateTimeField / DateTextField
  'itr-date': 'Date',
  'itr-time': 'Heure',
  'itr-your-time': 'Votre heure :',
  'itr-date-placeholder': 'mm/jj/aaaa',
};

export default {
  en,
  es,
  fr,
  'fr-ca': fr,
};
